import yup from 'utils/yup';

export const initialFlaggedEntriesFormData = {
  job_ids: [] as any,
  user_ids: [] as any,
  date_range: [null, null] as any,
};

export const flaggedEntriesValidationSchema = yup.object().shape({
  date_range: yup
    .array()
    .of(yup.date().nullable())
    .test(
      'both-dates-required',
      'Both start and end date are required',
      value => Array.isArray(value) && value.length === 2 && value.every(date => date !== null)
    )
    .required('Date range is required'),
});
